function n(e, r) {
  return e && r[e];
}
export {
  n as g
};
//# sourceMappingURL=get-encore-value-Di648HqV.mjs.map
